// import _ from 'lodash'

export default (apiMethods, endpoints) => ({
    getNotifications: () => {
        return apiMethods.get(endpoints.GET_NOTIFICATIONS_ENDPOINT);
    },
    addNotification: (notificationData) => {

        let formdata = new FormData()
        Object.keys(notificationData).forEach(key => {
            if (notificationData[key]){
                formdata.append(key, notificationData[key])
            }
        })
        formdata.append('constant','NOTIFICATIONS')
        
        return apiMethods.post(endpoints.ADD_NOTIFICATION_ENDPOINT, formdata, {
            'Content-Type': 'multipart/form-data'
        })
    },
    
    updateNotification: (notificationId, notificationData) => {
        
        let formdata = new FormData()
        Object.keys(notificationData).forEach(key => {
            if (notificationData[key]) {
                formdata.append(key, notificationData[key])
            }
        })
        formdata.append('constant','NOTIFICATIONS')

        return apiMethods.put(endpoints.UPDATE_NOTIFICATION_ENDPOINT + '/' + notificationId, formdata, {
            'Content-Type': 'multipart/form-data'
        })
    },
    toggleNotification: (notificationId) => {
        
        return apiMethods.get(endpoints.TOGGLE_NOTIFICATION_ENDPOINT + '/' + notificationId)
    },
    getNotificationCategories: () => {
        return apiMethods.get(endpoints.GET_NOTIFICATION_CATEOGIRES_ENDPOINT);
    },
    deleteNotification: (notificationId) => {
        return apiMethods.delete(endpoints.DELETE_NOTIFICATION_ENDPOINT + '/' + notificationId);
    },
    getUserNotifications: () => {
        return apiMethods.get(endpoints.GET_USER_NOTIFICATIONS_ENDPOINT)
    }
})



// WEBPACK FOOTER //
// ./src/lib/api-notification.js